import { makeAutoObservable, runInAction } from 'mobx';
import agent from '../api/agent';
import { CuotasMod } from '../models/CuotasMod';
import { DPI } from '../models/dpi';
import { createCATCursos } from '../models/CATCursos';
import { CATEdiciones } from '../models/CATEdiciones';
import { getTranxTipoCta } from '../models/getTranxTipoCta';
import { RecibosFormValues, RecibossMod } from '../models/RecibosMod';
import jsPDF from 'jspdf';
import { RecibosAgenciaFormValues, RecibosAgenciaMod } from '../models/PagoAgenciaMod';

export default class PagoAgenciaStore {

    CCTOperacionRegistry = new Map<any, CuotasMod>();
    CATCoursesRegistry = new Map<any, createCATCursos>();
    CATEdicionesRegistry = new Map<any, CATEdiciones>();
    TransXTipoCta = new Map<any, getTranxTipoCta>();

    DPIRegistry = new Map<any, CuotasMod>();
    CrearReciboAgencia = new Map<any, RecibosAgenciaMod>();

    selectedCuotasMod: CuotasMod | undefined = undefined;
    selectedReciboAgenciaMod: RecibosAgenciaMod | undefined = undefined;
    selectedDPI: DPI | undefined = undefined;

    editMode = false;
    loading = false;
    loadingInitial = false;
    saldo_actual_total: string = ""
    consulta = '';
    recibos: any;
    monto: any;
    cuenta: any;

    constructor() {
        makeAutoObservable(this)
    }

    get PlanCuotas() {
        return Array.from(this.CCTOperacionRegistry.values());
    }

    get CATCoursesInfo() {
        return Array.from(this.CATCoursesRegistry.values());
    }
    get dpiByCodigo() {

        return Array.from(this.DPIRegistry.values());
    }

    get groupedCCTMovimientos() {
        return this.CCTOperacionRegistry
    }
    loadEditions = async (codigocurso: number) => {
        if (codigocurso == undefined) {
            codigocurso = 0;
        }
        try {
            const getEditions: CATEdiciones[] = await agent.getCATEdiciones.getEditionsByCourse(codigocurso);
            return Array.from(getEditions);
        } catch {
            return Array.from(this.CATEdicionesRegistry.values());
        }

    }

    loadTransXTipoCta = async (codigocuenta: string) => {
        try {
            const getTrans: getTranxTipoCta[] = await agent.CCTTiposTransXTipoCtas.movimientos(codigocuenta);
            return Array.from(getTrans);
        } catch {
            return Array.from(this.TransXTipoCta.values());
        }

    }

    loadCourses = async () => {
        const getCursos: createCATCursos[] = await agent.CATCursos.getCourses();
        return Array.from(getCursos);
    }

    private getConsulta = (id: any) => {
        return this.DPIRegistry.get(id);
    }

    setLoadingInitial = (state: boolean) => {
        this.loadingInitial = state;
    }

    createRecibosAgenciaMod = async (ReciboAgenciaMod: RecibosAgenciaFormValues, dpi: any, names: any, apellidos: any, nit: any, descripcion: any) => {
        try {
            await agent.Recibo.createReciboAgencia(ReciboAgenciaMod).then(response => {
                const recibos = Object.values(response)
                this.recibos = recibos[0];
                this.monto = recibos[4]
                this.cuenta = recibos[2]
                this.crearPdfReciboAgencia(this.recibos, this.monto, this.cuenta, dpi, names, apellidos, nit, descripcion)
                return Array.from(recibos);

            });

            runInAction(() => {
                this.selectedReciboAgenciaMod = ReciboAgenciaMod;
                this.loading = false;
            })

        } catch (error) {
            runInAction(() => {
                this.loading = false;
            })
        }
    }

    private setRecibo = (data: RecibosAgenciaMod) => {
        this.CrearReciboAgencia.set(data.id, data);
    }

    PdfRecibo = async (id: number) => {
        this.loadingInitial = true;
        try {
            this.CrearReciboAgencia.clear()
            const CCTRecibosAgencia: RecibosAgenciaMod[] = await agent.Recibo.PdfReciboAgencia(id);
            CCTRecibosAgencia.forEach(element => {
                this.setRecibo(element);
            })
            this.setLoadingInitial(false);
        } catch (error) {
            this.setLoadingInitial(false);
        }
    }

    crearPdfReciboAgencia(recibo: any, montos: any, cuenta: any, dpi: string, names: any, apellidos: any, nit: any, descripcion: any) {

        let ceros = "";
        let diaActual = new Date();
        var day = diaActual.getDate();
        var month = diaActual.getMonth() + 1;
        var year = diaActual.getFullYear();
        let fecha = day + '/' + month + '/' + year;

        const nf1 = new Intl.NumberFormat("es-MX");
        const doc = new jsPDF('portrait');

        var arancel = nf1.format(montos)
        if ((montos % 1) == 0) {
            arancel = "Q. " + arancel + ".00"
        }

        if (recibo < 100) {
            ceros = "0000"
        } else if (recibo < 1000) {
            ceros = "000"

        } else if (recibo < 10000) {
            ceros = "00"
        } else if (recibo < 100000) {
            ceros = "0"
        }

        doc.setLineWidth(1)
        doc.rect(5, 14, 200, 130)
        doc.setLineWidth(0.5)
        doc.rect(5, 14, 200, 35)
        doc.rect(55, 14, 100, 35)
        doc.rect(5, 129.5, 200, 15)

        doc.setLineWidth(1)
        doc.rect(5, 155, 200, 130)
        doc.setLineWidth(0.5)
        doc.rect(5, 155, 200, 35)
        doc.rect(55, 155, 100, 35)
        doc.rect(5, 270.5, 200, 15)

        doc.setFontSize(20);
        doc.text("INAP", 22, 28);
        doc.setFontSize(8);
        doc.text("Instituto Nacional de", 17, 34);
        doc.text("Administración Pública", 15, 38);

        doc.setFontSize(18);
        doc.text("Recibo de Pago", 84, 31);

        doc.setFontSize(8);
        doc.text("Original ", 174, 23)
        doc.setFontSize(16);
        doc.text("No. Recibo: ", 165, 30)
        doc.setFontSize(20);
        doc.text(ceros + recibo.toString(), 168, 40)

        doc.setFontSize(12);
        doc.text("Nombre:" + "                     " + names + " " + apellidos, 15, 60)
        doc.text("Dpi:" + "                            " + dpi, 15, 66)
        doc.text("Nit:" + "                             " + nit, 15, 72)
        doc.text("Código de Curso:" + "      " + cuenta, 15, 78)
        doc.text("Arancel:" + "                     " + arancel, 15, 84)

        doc.text("Descripción:", 15, 93)
        var descipcionVariable = doc.splitTextToSize(descripcion, 145)
        doc.text(descipcionVariable, 55, 93);
        doc.text("Este no es un comprobante de pago. Su recibio 63A2 será entregado por el receptor.", 15, 113)
        doc.text("Realizar el pago en agencias Banrural, utilizando el número de transacción: ", 15, 123)

        doc.setFont('helvetica', 'bold')
        doc.setFontSize(14);
        doc.text("ATX-249-413-1", 160, 123)

        doc.setFont('helvetica', 'normal')
        doc.setFontSize(8);
        doc.text("Fecha de Impresión:  " + fecha, 15, 137)

        doc.setFontSize(10);
        doc.text("-------------------------------------------------------------------------------------------------------------------------------------------------------------------------", 6, 150);
        
        doc.setFontSize(20);
        doc.text("INAP", 22, 168);
        doc.setFontSize(8);
        doc.text("Instituto Nacional de", 17, 174);
        doc.text("Administración Pública", 15, 178);

        doc.setFontSize(18);
        doc.text("Recibo de Pago", 84, 173);

        doc.setFontSize(8);
        doc.text("Duplicado", 173, 163)
        doc.setFontSize(16);
        doc.text("No. Recibo: ", 165, 170)
        doc.setFontSize(20);
        doc.text(ceros + recibo.toString(), 168, 180)

        doc.setFontSize(12);
        doc.text("Nombre:" + "                     " + names + " " + apellidos, 15, 204)
        doc.text("Dpi:" + "                            " + dpi, 15, 210)
        doc.text("Nit:" + "                             " + nit, 15, 216)
        doc.text("No. de cuenta:" + "           " + cuenta, 15, 222)
        doc.text("Arancel:" + "                     " + arancel, 15, 228)

        doc.text("Descripción:", 15, 237)
        var descipcionVariable = doc.splitTextToSize(descripcion, 145)
        doc.text(descipcionVariable, 55, 237);

        doc.setFontSize(12);
        doc.text("Este no es un comprobante de pago. Su recibio 63A2 será entregado por el receptor.", 15, 155)
        doc.text("Realizar el pago en agencias Banrural, utilizando el número de transacción ", 15, 265)

        doc.setFont('helvetica', 'bold')
        doc.setFontSize(14);
        doc.text("ATX-249-413-1", 160, 265)
        
        doc.setFont('helvetica', 'normal')
        doc.setFontSize(8);
        doc.text("Fecha de Impresión:  " + fecha, 15, 279)

        // doc.text(SaldosReportes.fechaInicial, 115, 20)
        window.open(URL.createObjectURL(doc.output("blob")));
        doc.save('recibo.pdf');
        // doc.save("REPORTE_DE_SALDOS.pdf");
    }
}

export const CoursesData = async () => {
    try {
        const getCursos: createCATCursos[] = await agent.CATCursos.getCourses();
    }
    catch {
    }
}  